import React from 'react'
import Img from "gatsby-image"

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class WichitaLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Wichita, KS" />
        <LocationMicroNav />

        <LocationContent 
          category="Promoting Ridership" 
          title="Take the Plunge"
          story={ [ 'The PeopleForBikes blog is the place to go for stories about infrastructure, business, political issues and stories about everyday bike riders. One of our most popular posts of 2017 told the story of a bike lane in Wichita, Kansas. Two weeks after an anonymous group of activists dropped toilet plungers along a bike lane to create protection from vehicles, the city installed permanent flexposts to make the route safer. Other popular posts told tales of mountain bike trails in Minnesota, AAA on-the-road bike service and e-bike myths. ', <a href="https://peopleforbikes.org/blog/" target="_blank">Click here</a>, ' to see what else was top of the blog in 2017.' ] }
        />      
        <Img
          title="Wichita"
          alt="Cyclofest expo picture"
          sizes= { this.props.data.wichitaImage.sizes }
        />              

        <LocationRelated 
          prevLocationName="St. Pete Beach, FL"
          prevLocationPath="st-pete-beach"
          prevLocationImgPath= { this.props.data.wichitaPrevImage }
          nextLocationName="Arizona"
          nextLocationPath="arizona"
          nextLocationImgPath= { this.props.data.wichitaNextImage }
        /> 
      </div>
    )
  }
}

export default WichitaLocation

export const wichitaImageQuery = graphql`
  query wichitaImageQuery {
    wichitaImage: imageSharp(id: { regex: "/PFB_Wichita/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    wichitaPrevImage: imageSharp(id: { regex: "/PFB_STPETE/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    wichitaNextImage: imageSharp(id: { regex: "/PFB_ARIZONA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/wichita.js